import { render, staticRenderFns } from "./ns-orders-filter-popup.vue?vue&type=template&id=96c49406&"
import script from "./ns-orders-filter-popup.vue?vue&type=script&lang=ts&"
export * from "./ns-orders-filter-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports